// venylix — script propio (vanilla JS, sin librerías externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initFaqAcordeon();
  initVariantesProducto();
  initCopiarCodigo();
});

// Copiar código de descuento al portapapeles
function initCopiarCodigo() {
  var botones = document.querySelectorAll('[data-vnx-copiar]');
  if (!botones.length) return;
  botones.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var codigo = btn.getAttribute('data-vnx-copiar');
      var ayuda = btn.parentElement.querySelector('[data-vnx-promo-ayuda]');
      var textoOriginal = ayuda ? ayuda.textContent : null;
      function marcarCopiado() {
        if (!ayuda) return;
        ayuda.textContent = '¡Código copiado!';
        setTimeout(function () { ayuda.textContent = textoOriginal; }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(marcarCopiado).catch(function () {});
      } else {
        var aux = document.createElement('textarea');
        aux.value = codigo;
        aux.style.position = 'fixed';
        aux.style.opacity = '0';
        document.body.appendChild(aux);
        aux.select();
        try { document.execCommand('copy'); marcarCopiado(); } catch (e) {}
        document.body.removeChild(aux);
      }
    });
  });
}

// Revela con stagger cualquier .vnx-reveal cuando entra en pantalla
function initReveal() {
  var els = document.querySelectorAll('.vnx-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('vnx-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vnx-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

// Cifras animadas (count-up) — data-vnx-hasta="45"
function initContador() {
  var els = document.querySelectorAll('[data-vnx-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-vnx-hasta') || '0');
      var decimales = (el.getAttribute('data-vnx-hasta') || '').includes('.') ? 1 : 0;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = valor.toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toFixed(decimales);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

// Galería de producto: click en miniatura cambia la imagen principal
function initGaleriaProducto() {
  var galeria = document.querySelector('[data-vnx-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-vnx-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-vnx-miniatura]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-vnx-miniatura');
      principal.setAttribute('src', src);
      minis.forEach(function (m) { m.classList.remove('vnx-miniatura--activa'); });
      mini.classList.add('vnx-miniatura--activa');
    });
  });
}

// FAQ en acordeón accesible
function initFaqAcordeon() {
  var items = document.querySelectorAll('[data-vnx-faq-pregunta]');
  if (!items.length) return;
  items.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-vnx-faq-item]');
      var abierto = item.classList.contains('vnx-faq-item--abierto');
      item.parentElement.querySelectorAll('[data-vnx-faq-item]').forEach(function (i) {
        i.classList.remove('vnx-faq-item--abierto');
        i.querySelector('[data-vnx-faq-pregunta]').setAttribute('aria-expanded', 'false');
      });
      if (!abierto) {
        item.classList.add('vnx-faq-item--abierto');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

// Selector de variantes de producto (si hay más de una)
function initVariantesProducto() {
  var form = document.querySelector('[data-vnx-form-producto]');
  if (!form) return;
  var datos = form.querySelector('[data-vnx-variantes-json]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-vnx-precio-actual]');
  var precioComparado = document.querySelector('[data-vnx-precio-comparado]');
  var botonComprar = form.querySelector('[data-vnx-boton-comprar]');
  var selects = form.querySelectorAll('[data-vnx-opcion]');
  if (!datos || !selects.length) return;

  var variantes;
  try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }

  function varianteActual() {
    var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
  }

  function actualizar() {
    var v = varianteActual();
    if (!v) return;
    idInput.value = v.id;
    if (v.image) {
      var principal = document.querySelector('[data-vnx-imagen-principal]');
      if (principal) principal.setAttribute('src', v.image);
    }
    if (precioEl && v.price != null) precioEl.textContent = v.priceFormatted;
    if (precioComparado) {
      if (v.compareAtPriceFormatted) {
        precioComparado.textContent = v.compareAtPriceFormatted;
        precioComparado.style.display = '';
      } else {
        precioComparado.style.display = 'none';
      }
    }
    if (botonComprar) {
      if (v.available) {
        botonComprar.disabled = false;
        botonComprar.textContent = botonComprar.getAttribute('data-vnx-texto-disponible');
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.getAttribute('data-vnx-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}
